<template>
  <article class="user_view">
    <left-menu/>
    <section class="user_view__header">
      <div @click="$router.push({path: prevRoute})" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <div class="user_view__header--info" style="display:flex"> 
        <div>
          <h2>{{user.name}} {{user.last_name}} </h2>
          <h4>CC. {{user.id_card}}</h4>
          <div class="user_view__header--sec1">
            <div class="date_filter">
              <input @input="showDate" id="fecha" v-model="date" type="month" class="date_filter__selector">
              <button :class="{'active':true}" @click="showDate" class="secondary_button" >ACTUALIZAR</button>
            </div>
          </div>
        </div>
        <div class="turn_header">
          <div class="turn_header__left">
            <h5>
              Desde Siempre
            </h5>
            <h3>
              {{table.total}}
            </h3>
            <h4>
              Total turnos
            </h4>
          </div>
          <div class="turn_header__right">
            <h5>
                {{selectedDate}}
            </h5>
            <div class="turn_header__right--container">
              <div>
                <h3>
                  {{table.month.total}}
                </h3>
                <h4>
                  Total turnos
                </h4>
              </div>
              <div class="turn_header__right--container--day">
                <h3>
                  {{table.month.diurnal}}
                </h3>
                <h4>
                  Diurnos
                </h4>
              </div>
              <div class="turn_header__right--container--night">
                <h3>
                  {{table.month.nocturn}}
                </h3>
                <h4>
                 Nocturnos
                </h4>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <calendar :currentMonth="this.date" :unprocessedTurns="this.turns"/>
    </section>
    
  </article>
</template>

<script>
import Calendar from './../shared/Calendar';
import moment from 'moment';
export default {
  data(){
    return{
      date: localStorage.getItem("mySelectedDate")?localStorage.getItem("mySelectedDate"):new moment().format("YYYY-MM"),
      user:{
        name: '',
        last_name:'',
        id_card:'',
        card_company:''
      },
       table:{
        total: 0,
        month:{
          total:0,
          diurnal:0,
          nocturn:0
        }
      },
      guards:[],
      unprocessedTurns:[        
      ],
      prevRoute:'',
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name!="GuardTurn"){
        vm.prevRoute = from.path;
        localStorage.setItem("calendarRoute",from.path)
      }
      
    })
  },
  components:{
      'calendar':Calendar, 
  },
  mounted(){
    //console.log(new moment().format("YYYY-DD-MM"));
    //console.log(document.getElementById('fecha'))
    
    if(localStorage.getItem("mySelectedDate")){
      var myDate=localStorage.getItem("mySelectedDate");
    }else{
      var myDate=new moment().format("YYYY-MM");
      localStorage.setItem("mySelectedDate",myDate);
    }
    document.getElementById('fecha').value =  myDate;
  },
  
  created(){
    //this.user.name = this.$route.query.guard.user.name;
    //this.user.last_name = this.$route.query.guard.user.last_name;
    this.prevRoute=localStorage.getItem("calendarRoute");
    this.user.id_card = this.$route.params.id;
    //this.user.card_company = this.$route.query.guard.user.card_company;
    if(localStorage.getItem("mySelectedDate")){
      var myDate=localStorage.getItem("mySelectedDate");
    }else{
      var myDate=new moment().format("YYYY-MM");
      localStorage.setItem("mySelectedDate",myDate);
    }
 
    var thisMonth = myDate;
    //console.log(thisMonth);
    const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
    };
    var card=JSON.parse(localStorage.getItem("user")).id_card
    this.$resource('turns/' + this.$route.params.id,{},customActions).get({"date": thisMonth, "id_card":card})
    .then(function(data){
      this.unprocessedTurns=data.body.turns;
      this.user.name = data.body.guard.name;
      this.user.last_name = data.body.guard.last_name; 
      this.table = data.body.table;
    });

    
  },
  methods:{
    showDate(){
      console.log(this.date);
      localStorage.setItem("mySelectedDate",this.date);
      this.unprocessedTurns = [];
      const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
      };
      var card=JSON.parse(localStorage.getItem("user")).id_card
      this.$resource('turns/' + this.$route.params.id,{},customActions).get({"date": this.date,"id_card":card})
      .then(function(data){
        //console.log(data.body.turns);
        this.unprocessedTurns=data.body.turns;
        this.table = data.body.table;
      });
    }
  },
  computed:{
    turns: function(){
      return this.unprocessedTurns;
    },
    selectedDate: function(){
      return moment(this.date).lang('es').format('MMMM YYYY');
    },
  }
  
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Guard.vue